<template>
  <div v-if="show" class="dialog-add-account__form-agree">
    <label class="input__item-checkbox dialog-add-account__form-agree-container">
      <input
        type="checkbox"
        required
        :checked="isOfferAgreementChecked"
        @change="$emit('update:offer_agreement_accepted', $event.target.checked)"
      />
      <span class="input__item-checkbox__check">
        <img src="@/assets/icons/icon-done.svg" />
      </span>
      <span class="input__item-checkbox__info">
        <span class="input__item-checkbox__title">
          {{ $t('business_account_data.agree_with') }}
          <a href="https://profitads.ru/dogovor-oferty/" target="_blank">{{
            $t('business_account_data.offer_contract')
          }}</a>
        </span>
      </span>
    </label>
    <label class="input__item-checkbox dialog-add-account__form-agree-container">
      <input
        type="checkbox"
        required
        :checked="isAgreePolicyChecked"
        @change="$emit('update:isAgreePolicy', $event.target.checked)"
      />
      <span class="input__item-checkbox__check">
        <img src="@/assets/icons/icon-done.svg" />
      </span>
      <span class="input__item-checkbox__info">
        <span class="input__item-checkbox__title">
          {{ $t('business_account_data.agree_to') }}
          <a href="https://profitads.ru/soglasie/" target="_blank">{{
            $t('business_account_data.processing')
          }}</a>
          {{ $t('business_account_data.and') }} {{ $t('business_account_data.accept_terms') }}
          <a href="https://profitads.ru/privacy-policy" target="_blank">{{
            $t('business_account_data.accept_terms_policy')
          }}</a>
        </span>
      </span>
    </label>
    <div v-if="error" class="form-input__error" v-text="error" />
  </div>
</template>

<script>
export default {
  name: 'AgreementCheckboxes',
  props: {
    value: {
      type: Object,
      required: true,
      validator: (value) => {
        return 'offer_agreement_accepted' in value && 'isAgreePolicy' in value;
      },
    },
    error: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isOfferAgreementChecked() {
      return !!this.value.offer_agreement_accepted;
    },
    isAgreePolicyChecked() {
      return !!this.value.isAgreePolicy;
    },
  },
  emits: ['update:offer_agreement_accepted', 'update:isAgreePolicy'],
};
</script>
